import {NavLink, useNavigate} from "react-router-dom";
import React, {Fragment, useContext} from "react";
import {AuthContext} from "../../context/authContext";
import Badge from "react-bootstrap/Badge";

const ProviderUserMenuItems = () => {
  const navigate = useNavigate()
  const {user, logout} = useContext(AuthContext)

  const onLogout = (event) => {
    event.preventDefault()
    logout()
    navigate('/login')
  }

  return (
    <Fragment>
      <li className='nav-item'><NavLink to="/profile" className="nav-link dropdown-item close-nav">Profil</NavLink>
      </li>
      <li className='nav-item'><NavLink to="/notifications" className="nav-link dropdown-item close-nav">
        Notificari
        <Badge pill className='ms-2' bg='danger'>{user.unreadNotificationsCount}</Badge>
      </NavLink></li>
      <li className='nav-item'><NavLink to="/settings" className="nav-link dropdown-item close-nav">Setari</NavLink>
      </li>
      <li className='nav-item'>
        <hr className="dropdown-divider"/>
      </li>
      <li className='nav-item'><NavLink to="/logout" onClick={onLogout}
                                        className="nav-link dropdown-item close-nav">Delogare</NavLink>
      </li>
    </Fragment>
  )
}
export default ProviderUserMenuItems